import { render, staticRenderFns } from "./m-deep-badge-outline.vue?vue&type=template&id=2db0298a&scoped=true&"
import script from "./m-deep-badge-outline.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-deep-badge-outline.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-deep-badge-outline.vue?vue&type=style&index=0&id=2db0298a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db0298a",
  null
  
)

export default component.exports